import { Btn } from "./styles";

export const Button = ({ text }: any) => {
  return (
    <>
      <Btn>{text}</Btn>
    </>
  );
};
